export enum COLORS {
  PRIMARY_BLACK = 'var(--color-primary-black)',
  PRIMARY_BLUE = 'var(--color-primary-blue)',
  PRIMARY_GRAY = 'var(--color-primary-gray)',
  PRIMARY_WHITE = 'var(--color-primary-white)',
  SECONDARY_GRAY = 'var(--color-secondary-gray)',
  SECONDARY_STEEL_BLUE = 'var(--color-secondary-steel-blue)',
  SECONDARY_BLUE_GRAY = 'var(--color-secondary-blue-gray)',
  SECONDARY_PALE_BLUE_GRAY = 'var(--color-secondary-pale-blue-gray)',
  ACCENT_GREEN = 'var(--color-accent-green)',
  ACCENT_LIGHT_GREEN = 'var(--color-accent-light-green)',
  ACCENT_RED = 'var(--color-accent-red)',
  ACCENT_PEACH = 'var(--color-accent-peach)',
  ACCENT_AMBER = 'var(--color-accent-amber)',
  ACCENT_BEIGE = 'var(--color-accent-beige)',
  ACCENT_DARK_GRAY = 'var(--color-accent-dark-gray)',
  ACCENT_LIGHT_GRAY = 'var(--color-accent-light-gray)'
}
